module.exports = {"150702001":"正阳街道","150702002":"健康街道","150702003":"靠山街道","150702004":"胜利街道","150702005":"呼伦街道","150702007":"建设街道","150702008":"东山街道","150702100":"哈克镇","150702101":"奋斗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150702.json
// module id = 533
// module chunks = 0